var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.buttonClass,style:(_vm.buttonStyle)},[_c('v-btn',{staticClass:"mb-3",attrs:{"rounded":"","width":_vm.buttonWidth,"to":{ name: _vm.to },"large":"","dark":"","color":_vm.btnColor}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }